import React from 'react'
import PropTypes from 'prop-types'
import { formatDateTime } from '../../../utils/dateHelpers'

const CARD_CLASS = 'tw:flex! tw:flex-col tw:gap-2 tw:rounded-sm! tw:bg-gray-50 tw:px-6 tw:py-4'
const TITLE_CLASS = 'tw:text-base! tw:font-medium! tw:text-gray-900! tw:m-0! tw:mb-2!'
const ROW_CLASS = 'tw:text-sm tw:text-gray-700 tw:m-0! tw:break-words'
const LABEL_CLASS = 'tw:text-gray-600'
const VALUE_CLASS = 'tw:text-gray-900'
const LINK_CLASS = 'tw:text-gray-900! tw:underline! tw:hover:text-gray-900!'

const detailRow = (label, value) => (
  <p key={label} className={ROW_CLASS}>
    <span className={LABEL_CLASS}>{`${label} : `}</span>
    <span className={VALUE_CLASS}>{value}</span>
  </p>
)

const EMPTY_RECIPIENTS = []

const IssueDetailsCard = ({
  collectName, alertName, triggeredAt, scheduledAt = null,
  resourceName, resourceUrl, recipients = EMPTY_RECIPIENTS
}) => {
  let resourceLink = resourceName || '—'
  if (resourceUrl) {
    resourceLink = (
      <a className={LINK_CLASS} href={resourceUrl} rel="noreferrer" target="_blank">
        {resourceName}
      </a>
    )
  }
  return (
    <section className={CARD_CLASS}>
      <h3 className={TITLE_CLASS}>Détails de l’alerte</h3>
      {detailRow('Collecte', collectName)}
      {detailRow('Nom de l’alerte', alertName)}
      {detailRow('Déclenchement', formatDateTime(triggeredAt))}
      {scheduledAt ? detailRow('Date de planification', formatDateTime(scheduledAt)) : null}
      {detailRow('Nom de la ressource', resourceLink)}
      {recipients.length > 0 ? detailRow('Destinataires', recipients.join(', ')) : null}
    </section>
  )
}

IssueDetailsCard.propTypes = {
  alertName: PropTypes.string,
  collectName: PropTypes.string,
  recipients: PropTypes.arrayOf(PropTypes.string),
  resourceName: PropTypes.string,
  resourceUrl: PropTypes.string,
  scheduledAt: PropTypes.string,
  triggeredAt: PropTypes.string
}

IssueDetailsCard.defaultProps = {
  alertName: '',
  collectName: '',
  recipients: [],
  resourceName: '',
  resourceUrl: '',
  scheduledAt: null,
  triggeredAt: ''
}

export default IssueDetailsCard
